import classNames from 'classnames';
import uniqueId from 'lodash/uniqueId';
import * as React from 'react';
import { List } from '../../Partials/List/List';
import { SingleContactBlock } from '../SingleContactBlock/SingleContactBlock';
import styles from './ContactListBlock.module.css';
import type { ContactListBlockProps } from './ViewModel/ContactListBlockProps.csharp';

export const ContactListBlock: React.FC<React.PropsWithChildren<ContactListBlockProps>> = props => {
    const { title, backgroundVariant, overrideItemsBackground, items } = props;

    return (
        <div className={classNames(styles.ContactListBlock, styles[`Variant--${backgroundVariant}`])}>
            <div className={styles.TitleWrapper}>
                <h2 className={styles.Title}>{title}</h2>
            </div>
            <List
                className={styles.List}
                items={items}
                renderItem={item => (
                    <li key={uniqueId('ContactListItem__')}>
                        <SingleContactBlock
                            {...item}
                            backgroundVariant={overrideItemsBackground ? backgroundVariant : item.backgroundVariant}
                            spacing="small"
                        />
                    </li>
                )}
            />
        </div>
    );
};
